import React from 'react';
import { Col, Row, Typography } from 'antd';
import fileCheckIcon from './../../images/file-check-regular-icon.svg';

const { Title } = Typography;

const SuccessSign = () => {

  return (
    <div className="text-center ant-layout-content-custom">
      <Row className="mb-4">
        <Col md={12} className="mx-auto">
          <img src={fileCheckIcon} className="mb-4" alt="" />          
          <Title level={2}>Tu contrato ya está revisado y validado</Title>
          <p className="mb-2">Una vez que todos hayan revisado y validado el documento, te enviaremos un correo para que firmes electrónicamente el contrato de arriendo de Notarisa</p>
        </Col>
      </Row>
    </div>
  );
};

export default SuccessSign;